'use client';
import { useEffect } from 'react';

import MapWrapper from '@/src/components/Compass/MapWrapper';
import Nav from '@/src/components/Navigation/Nav';
import { useCompassContext } from '@/src/libs/CompassContext';
import { initializeFirebase } from '@/src/utils/shared/initializeFirebase';

const Compass = () => {
  const ctx = useCompassContext();

  useEffect(() => {
    if (!ctx) return;
    if (!ctx?.state.firestore) {
      try {
        initializeFirebase(
          ctx,
          (process.env.useFirebaseEmulator as 'true' | 'false') ?? 'false'
        );
      } catch (error) {
        console.error('Error initializing Firebase:', error);
      }
    }
  }, [ctx?.state.firestore]);

  return (
    <div className="compass-shell h-screen flex flex-col">
      <Nav variant="plain" />
      <div className="w-full flex-grow flex flex-col md:flex-row overflow-auto">
        <MapWrapper />
      </div>
    </div>
  );
};

export default Compass;
